<template>
  <div class="page checkout company-context">
    <transition tag="section" name="slide-fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <div class="space-30"></div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    data () {
      return {
        tagInterval: false,
        loading: false
      }
    },
    computed: {
      ...mapState({
        company: state => state.company,
        user: state => state.user
      })
    },
    mounted () {
      this.tagInterval = this.setTagInterval()
      this.getCompany()
    },
    beforeDestroy () {
      if (this.tagInterval) {
        clearInterval(this.tagInterval)
      }
    },
    methods: {
      getCompany () {
        this.loadCompany()
          .then((response) => {
            this.saveCompany(response.data)
          })
      },
      ...mapActions(['loadCompany', 'saveCompany', 'unsetUser'])
    }
  }
</script>

<style lang="scss">
  @import "./sass/main";
</style>



// WEBPACK FOOTER //
// App.vue?6b3c36f7